//#region src/utils/cssuseragent.js
var e = (e, t, n) => {
	var r = " ua-", i = /\s*([-\w ]+)[\s/:]([\d_]+\b(?:[-._/]\w+)*)/, a = /([\w\-.]+[\s/][v]?[\d_]+\b(?:[-._/]\w+)*)/g, o = /\b(?:(blackberry\w*|bb10)|(rim tablet os))(?:\/(\d+\.\d+(?:\.\w+)*))?/, s = /\bsilk-accelerated=true\b/, c = /\bfluidapp\b/, l = /(\bwindows\b|\bmacintosh\b|\blinux\b|\bunix\b)/, u = /(\bandroid\b|\bipad\b|\bipod\b|\bwindows phone\b|\bwpdesktop\b|\bxblwp7\b|\bzunewp7\b|\bwindows ce\b|\bblackberry\w*|\bbb10\b|\brim tablet os\b|\bmeego|\bwebos\b|\bpalm|\bsymbian|\bj2me\b|\bdocomo\b|\bpda\b|\bchtml\b|\bmidp\b|\bcldc\b|\w*?mobile\w*?|\w*?phone\w*?)/, d = /(\bxbox\b|\bplaystation\b|\bnintendo\s+\w+)/, f = {
		parse: function(e, t) {
			var n = {};
			if (t && (n.standalone = t), e = ("" + e).toLowerCase(), !e) return n;
			for (var r, f, p = e.split(/[()]/), m = 0, h = p.length; m < h; m++) if (m % 2) {
				var g = p[m].split(";");
				for (r = 0, f = g.length; r < f; r++) if (i.exec(g[r])) {
					var _ = RegExp.$1.split(" ").join("_"), v = RegExp.$2;
					(!n[_] || Number.parseFloat(n[_]) < Number.parseFloat(v)) && (n[_] = v);
				}
			} else {
				var y = p[m].match(a);
				if (y) for (r = 0, f = y.length; r < f; r++) {
					var b = y[r].split(/[/\s]+/);
					b.length && b[0] !== "mozilla" && (n[b[0].split(" ").join("_")] = b.slice(1).join("-"));
				}
			}
			if (u.exec(e)) n.mobile = RegExp.$1, o.exec(e) && (delete n[n.mobile], n.blackberry = n.version || RegExp.$3 || RegExp.$2 || RegExp.$1, RegExp.$1 ? n.mobile = "blackberry" : n.version === "0.0.1" && (n.blackberry = "7.1.0.0"));
			else if (d.exec(e)) {
				n.game = RegExp.$1;
				var x = n.game.split(" ").join("_");
				n.version && !n[x] && (n[x] = n.version);
			} else l.exec(e) && (n.desktop = RegExp.$1);
			return n.intel_mac_os_x ? (n.mac_os_x = n.intel_mac_os_x.split("_").join("."), delete n.intel_mac_os_x) : n.cpu_iphone_os ? (n.ios = n.cpu_iphone_os.split("_").join("."), delete n.cpu_iphone_os) : n.cpu_os ? (n.ios = n.cpu_os.split("_").join("."), delete n.cpu_os) : n.mobile === "iphone" && !n.ios && (n.ios = "1"), n.opera && n.version ? (n.opera = n.version, delete n.blackberry) : s.exec(e) ? n.silk_accelerated = !0 : c.exec(e) && (n.fluidapp = n.version), n.edge && (delete n.applewebkit, delete n.safari, delete n.chrome, delete n.android), n.applewebkit ? (n.webkit = n.applewebkit, delete n.applewebkit, n.opr && (n.opera = n.opr, delete n.opr, delete n.chrome), n.safari && (n.chrome || n.crios || n.fxios || n.opera || n.silk || n.fluidapp || n.phantomjs || n.mobile && !n.ios ? (delete n.safari, n.vivaldi && delete n.chrome) : n.safari = n.version && !n.rim_tablet_os ? n.version : {
				419: "2.0.4",
				417: "2.0.3",
				416: "2.0.2",
				412: "2.0",
				312: "1.3",
				125: "1.2",
				85: "1.0"
			}[Number.parseInt(n.safari, 10)] || n.safari)) : n.msie || n.trident ? (n.opera || (n.ie = n.msie || n.rv), delete n.msie, delete n.android, n.windows_phone_os ? (n.windows_phone = n.windows_phone_os, delete n.windows_phone_os) : (n.mobile === "wpdesktop" || n.mobile === "xblwp7" || n.mobile === "zunewp7") && (n.mobile = "windows desktop", n.windows_phone = +n.ie < 9 ? "7.0" : +n.ie < 10 ? "7.5" : "8.0", delete n.windows_nt)) : (n.gecko || n.firefox) && (n.gecko = n.rv), n.rv && delete n.rv, n.version && delete n.version, n;
		},
		format: function(e) {
			function t(e, t) {
				e = e.split(".").join("-");
				var n = r + e;
				if (typeof t == "string") {
					t = t.split(" ").join("_").split(".").join("-");
					for (var i = t.indexOf("-"); i > 0;) n += r + e + "-" + t.substring(0, i), i = t.indexOf("-", i + 1);
					n += r + e + "-" + t;
				}
				return n;
			}
			var n = "";
			for (var i in e) i && e.hasOwnProperty(i) && (n += t(i, e[i]));
			return n;
		},
		encode: function(e) {
			var t = "";
			for (var n in e) n && e.hasOwnProperty(n) && (t && (t += "&"), t += encodeURIComponent(n) + "=" + encodeURIComponent(e[n]));
			return t;
		}
	};
	f.userAgent = f.ua = f.parse(t, n);
	var p = f.format(f.ua) + " js";
	return e.className = e.className ? e.className.replace(/\bno-js\b/g, "") + p : p.substr(1), f;
};
//#endregion
export { e as cssua };

//# sourceMappingURL=cssuseragent.js.map